<template>
  <div>
    <Form @submit="submit">
      <Field
        clearable
        v-model="device.name"
        label="设备名称"
        placeholder="请输入设备名称"
        :rules="[{ required: true, message: '设备名称必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/edit.png" />
      </Field>
      <Field
        :class="disabledUnit ? 'disabled' : ''"
        clearable
        v-model="device.sn"
        label="设备编号"
        placeholder="输入设备编号或扫一扫"
        :rules="[{ required: true, message: '设备编号必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/qrCode.png" />
        <WeChatIcon slot="right-icon" name="scan" @click="qrScan" />
      </Field>
      <Field
        :class="disabledUnit ? 'disabled' : ''"
        :disabled="disabledUnit"
        clearable
        v-model="device.unitName"
        label="所属单位"
        placeholder="请选择所属单位"
        readonly
        right-icon="arrow-down"
        @click="unitPanel = true"
        :rules="[{ required: true, message: '所属单位必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/unit.png" />
      </Field>
      <Field
        :class="disabledProduct ? 'disabled' : ''"
        clearable
        v-model="device.productName"
        label="产品类型"
        placeholder="请选择产品类型"
        readonly
        right-icon="arrow-down"
        @click="selectProduct()"
        :disabled="disabledProduct"
        :rules="[{ required: true, message: '产品类型必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/product.png" />
      </Field>
      <Field
        :class="disabledProduct ? 'disabled' : ''"
        :disabled="disabledProduct"
        clearable
        v-model="device.areaName"
        label="所属区域"
        placeholder="请选择所属区域"
        readonly
        right-icon="arrow-down"
        @click="areaPanel = true"
        :rules="[{ required: true, message: '所属区域必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/area.png" />
      </Field>
      <Field
        :class="disabledMap ? 'disabled' : ''"
        clearable
        v-model="device.location"
        label="设备坐标"
        placeholder="0,0"
        readonly
        :disabled="true"
        right-icon="location-o"
        @click="switchPanel('map')"
        :rules="[{ required: true, message: '设备坐标必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/lngLat.png" />
      </Field>
      <Field
        clearable
        v-model="device.address"
        label="详细地址"
        placeholder="请输入详细地址"
        type="textarea"
        autosize
        rows="1"
        :rules="[{ required: true, message: '详细地址必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/address.png" />
      </Field>
      <Field
        clearable
        label="安装位置"
        v-model="device.installLocation"
        placeholder="请输入安装位置"
        :rules="[{ required: true, message: '安装位置必填' }]"
      >
        <img slot="left-icon" src="../../assets/img/installLocation.png" />
      </Field>
      <div
        style="display:flex;justify-content : space-between;width:80%;margin:auto;"
      >
        <UploadImage
          :imageList="image1"
          style="margin-top:5px;margin-left:-15px"
          top="设备图"
          type="DeviceImage"
          :count="1"
          @imageChange="image1Change"
          edit
        />
        <UploadImage
          :imageList="image2"
          style="margin-top:5px;margin-left:-15px"
          top="标签图"
          type="DeviceImage"
          :count="1"
          @imageChange="image2Change"
          edit
        />
        <UploadImage
          :imageList="image3"
          style="margin-top:5px;margin-left:-15px"
          top="安装图"
          type="DeviceImage"
          :count="1"
          @imageChange="image3Change"
          edit
        />
        <UploadImage
          :imageList="image4"
          style="margin-top:5px;margin-left:-15px"
          top="全景图"
          type="DeviceImage"
          :count="1"
          @imageChange="image4Change"
          edit
        />
      </div>
      <div>
        <Button
          type="info"
          block
          style="width: 95% ; margin: 10px auto;"
          native-type="submit"
          >保存</Button
        >
      </div>
    </Form>
    <UnitPanel
      :show="unitPanel"
      type="unit"
      :units="unitTree"
      @panel="switchPanel"
    />
    <SelectProductPopup
      :products="products"
      :show="productPanel"
      @ok="onSelectProduct"
      @cancel="productPanel = false"
    />
    <SelectTreePopup
      :show="unitPanel"
      :defaultSelected="
        device.unitId ? { id: device.unitId, name: device.unitName } : {}
      "
      :treeData="unitTree"
      :defaultTitle="device.unitName || '选择单位'"
      @ok="onUnitOk"
      @cancel="onUnitCancel"
    />
    <SelectTreePopup
      :show="areaPanel"
      :defaultSelected="
        device.areaId
          ? {
              id: device.areaId,
              name: device.areaName,
              lng: device.lng,
              lat: device.lat,
            }
          : {}
      "
      :treeData="areas"
      :defaultTitle="device.areaName || '选择区域'"
      @ok="onAreaOk"
      @cancel="onAreaCancel"
    />
    <MapPanel
      :show="mapPanel"
      :areaId="device.areaId"
      @panel="switchPanel"
      :lng="device.lng"
      :lat="device.lat"
      type="map"
    />
  </div>
</template>

<script>
import { Button, Field, Form, Loading } from "vant";
import SelectProductPopup from "@/components/SelectPopup/SelectProductPopup";
import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup";
import UnitPanel from "@/components/UnitPanel";
import AreaPanel from "@/components/AreaPanel";
import UploadImage from "@/components/UploadImage";
import MapPanel from "@/components/MapPanelreport";
import WeChatIcon from "@/components/Icon/WeChatIcon";
import { mapGetters } from "vuex";
import wx from "weixin-js-sdk";

export default {
  components: {
    Form,
    Field,
    UploadImage,
    Button,
    SelectProductPopup,
    UnitPanel,
    AreaPanel,
    SelectTreePopup,
    MapPanel,
    Loading,
    WeChatIcon,
  },
  props: {},
  data() {
    return {
      deviceId: this.$route.params.gatewayId,
      device: {
        gatewayId: this.$route.params.gatewayId,
        id: null,
        sn: null,
        address: null,
        installLocation: null,
        unitId: null,
        unitName: null,
        productId: null,
        productName: null,
        areaId: null,
        areaName: null,
        lat: 0,
        lng: 0,
        location: "",
        image1: null,
        image2: null,
        image3: null,
        image4: null,
      },
      productPanel: false,
      unitPanel: false,
      areaPanel: false,
      mapPanel: false,
      data: [],
      areas: [],
      products: [],
    };
  },
  computed: {
    disabledSn() {
      return !this.deviceId;
    },
    disabledUnit() {
      return !this.deviceId;
    },
    disabledProduct() {
      return !this.deviceId || !this.device.unitId;
    },
    disabledMap() {
      return !this.device.areaId;
    },
    image1() {
      return this.device.image1 ? [this.device.image1] : [];
    },
    image2() {
      return this.device.image2 ? [this.device.image2] : [];
    },
    image3() {
      return this.device.image3 ? [this.device.image3] : [];
    },
    image4() {
      return this.device.image4 ? [this.device.image4] : [];
    },
    ...mapGetters({ unitTree: "global/unitList" }),
  },
  created() {
    if (this.deviceId == null) {
      const unit = this.$initUnit(this.device);
      unit && this.changeUnit(unit);
      this.$initProduct(this.device);
      //this.$initArea(this.device)
      //this.$initArea(this.device, {'lng': 'lng', 'lat': 'lat'})
    }
  },
  mounted() {},
  methods: {
    qrScan() {
      const This = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let resultStr = res.resultStr;
          let index = resultStr.indexOf(`CODE_128,`);
          if (index === -1) {
            This.device.sn = resultStr;
            this.onRefresh();
          } else {
            let len = resultStr.length;
            This.device.sn = resultStr.slice(index + 9, len - 1);
            this.onRefresh();
          }
        },
      });
    },
    changeUnit(unit) {
      this.device.unitId = unit.id;
      this.device.unitName = unit.name;
      this.getAreas(unit.areaId);
      this.getProducts(unit.id);
    },
    onUnitCancel() {
      this.unitPanel = false;
    },
    onUnitOk(data) {
      this.unitPanel = false;
      this.changeUnit(data);
    },
    onAreaCancel() {
      this.areaPanel = false;
    },
    onAreaOk(data) {
      console.error("选择区域", data);
      this.areaPanel = false;
      this.device.areaId = data.id;
      this.device.areaName = data.name;
      this.device.lat = data.lat;
      this.device.lng = data.lng;
    },
    switchPanel(type, data) {
      switch (type) {
        case "map":
          if (data && data !== "map") {
            if (data[0] !== 0 && data[1] !== 0) {
              let This = this;
              new AMap.Geocoder().getAddress(data, function(status, result) {
                This.device.address = result.regeocode.formattedAddress;
              });
              this.device.lng = data[0];
              this.device.lat = data[1];
            }
          }
          this.mapPanel = !this.mapPanel;
          break;
        default:
          break;
      }
    },
    getProducts(unitId) {
      this.$http.tokiot.sys.product.listAuthorized({ unitId }).then((res) => {
        if (res) {
          this.products = res;
        }
      });
    },
    selectProduct() {
      this.productPanel = true;
    },
    onCancel() {
      this.productPanel = false;
    },
    onSelectProduct(product) {
      this.device.productName = product.productName;
      this.device.productId = product.id;
      this.productPanel = false;
    },
    getAreas(areaId) {
      this.$http.tokiot.sys.area.v2.tree({ id: areaId }).then((areas) => {
        if (areas) {
          this.areas = [areas];
        }
      });
    },

    getDeviceDetail() {
      this.$http.tokiot.device.get({ id: this.deviceId }).then((res) => {
        if (res) {
          this.device = res;
        }
      });
    },

    submit() {
      this.$toast.loading("设备报装中");
      this.$http.tokiot.device.create(this.device).then((res) => {
        this.$toast.clear();
        if (res) {
          this.$toast.success("设备报装成功");
          setTimeout(() => {
            this.$router.history.go(-1);
          }, 500);
        }
      });
    },
    image1Change(imageList) {
      this.device.image1 = imageList[0];
    },
    image2Change(imageList) {
      this.device.image2 = imageList[0];
    },
    image3Change(imageList) {
      this.device.image3 = imageList[0];
    },
    image4Change(imageList) {
      this.device.image4 = imageList[0];
    },
  },
  watch: {
    "device.lng"() {
      this.device.location = this.device.lng + "," + this.device.lat;
    },
    "device.lat"() {
      this.device.location = this.device.lng + "," + this.device.lat;
    },
  },
};
</script>

<style></style>
